const EXPORT_VISIBLE_MESSAGE = 'Export from Current Page';
const EXPORT_FILTERED_MESSAGE = 'Export from Current Filters';
const EXPORT_ALL_MESSAGE = 'Export All';

enum ExportMode {
    /** The claims currently visible to the user will be exported. */
    Visible,
    /** The claims that appear in the current filters will be exported. */
    Filtered,
    /** Everything will be exported. */
    All
}

const allExportModes: ReadonlySet<ExportMode> = new Set([ExportMode.All, ExportMode.Filtered, ExportMode.Visible]);

function isExportMode(value: any): value is ExportMode {
    const valueType = typeof value;
    return (valueType === 'number' || valueType === 'string')
        && allExportModes.has(Number(value));
}

export { EXPORT_VISIBLE_MESSAGE, EXPORT_FILTERED_MESSAGE, EXPORT_ALL_MESSAGE, ExportMode, isExportMode };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/export.ts